import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const updateCollateralApi = createAsyncThunk("updateCollateral", async (formData) => {
    const response = await axiosInstance.post(`/updatecollateral/${formData._id}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
});

const updateCollateralSlice = createSlice({
    name: "updateCollateral",
    initialState: {
        updateCollateral: [],
        errors: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateCollateralApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateCollateralApi.fulfilled, (state, action) => {
                state.updateCollateral = action.payload;
                state.loading = false;
            })
            .addCase(updateCollateralApi.rejected, (state, action) => {
                state.errors = action.payload || action.error.message;
                state.loading = false;
            });
    },
});

export default updateCollateralSlice.reducer;
